<template>
    <div class="bg" :style="style">
        <header>
            <div class="navbar fixed-top">
                <router-link class="back" to="/" v-if="!isHome">
                    Back to Home
                </router-link>
                <router-link class="navbar-brand" to="/"  v-if="isHome">
					<img src="img/logo.svg" alt="Insurance4Models" />
				</router-link>
                <button type="button" class="c-hamburger c-hamburger--htx toggle-menu" @click="toggleMenu">
                    <span>toggle menu</span>
                </button>
            </div>
            <ToggleMenu v-on:logout="logout"/>
        </header>
        <main>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <transition name="component-fade" mode="out-in">           
                            <router-view v-on:set-style="setStyle"></router-view>
                        </transition>
                    </div>
                </div>
            </div>
        </main>
        <Footer v-if="!loading"/>
    </div>
</template>

<script>
    //import NeedHelp from '../components/NeedHelp'
    import ToggleMenu from '../components/ToggleMenu'
    import Footer from '../components/Footer'


    export default {
        name: 'MainLayout',
        components: {
            ToggleMenu,
            Footer
            //NeedHelp
        },
        created() {
            document.body.classList.remove('mins'); // per background nero
            //console.log(this.$route);
        },
        data: function () {
            return {
                menuIsOpen: false,
                style : '', 
            }
        },
        computed: {
            isHome(){
                return this.$route.path == "/"
            },
            loading() {
                return this.$store.state.loader.loading;
            }
        },
        /*watch: {
            '$route' () {
                this.toggleMenu(); // moved in router beforeEach
            }
        },*/
        methods: {
            toggleMenu() {
                this.$store.dispatch('toggleMenu');
            },
            logout(){
                this.$store.dispatch('logout').then(() => {
                    this.$router.push('/login')
                });
            },
            setStyle: function(style){
                this.style = style
            },
        },
    };
</script>

<style scoped>
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>